module.exports = __webpack_public_path__ + "static/CircularStd-Black-62a02cf999ab28b933be14f4f2109735.ttf";